module.exports = __webpack_public_path__ + "static/img/Charlie-Guymer.6656a0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Charlie-Guymer.jpg
// module id = Ue5r
// module chunks = 0